import { get, patch, post } from "../config/user-api";

export const Gateway = {
  create: (props: { slug: string; title?: string; description?: string }) =>
    post(`gateway`, props),
  getSelf: () => get(`gateway/self`),
  update: (props: any) => patch(`gateway/self`, props),
};
